import { setRoomEditData } from '@/actions/room';
import {
  calculateTopThreeEmojisUsed,
  calculateTotalCountLikes,
} from '@/helpers/dataHelper';
import { emojis, getReactColor } from '@/helpers/index';
import { Dropdown, Typography } from 'antd';
import moment from 'moment';
import { useDispatch } from 'react-redux';

const CommentContent = ({
  comment,
  setIsCommentReaction,
  setReactionCommentId,
  setReactionCommentData,
  setEmojiCountModal,
  onCommentLikeClick,
  setCommentUserName,
  handleShowReplyClick,
  onReplyClick,
  each,
  user,
  CommentMenu,
}) => {
  const { Text } = Typography;
  const dispatch = useDispatch();

  return (
    <>
      <div className="d-flex justify-content-start">
        <div>
          <div
            className="py-1 px-2 position-relative"
            style={{
              backgroundColor: 'rgb(240, 242, 245)',
              borderRadius: '14px',
            }}
          >
            <Text style={{ fontWeight: '600' }}>
              {comment?.created_by?.first_name} {comment?.created_by?.last_name}
            </Text>
            <p
              className="text-justify m-0 "
              style={{
                wordBreak: 'break-all',
              }}
            >
              {comment?.text}
            </p>
            {(comment?.reactions?.length > 0 || comment?.no_of_likes > 0) && (
              <div
                className={`position-absolute bg-primary text-white px-1 cursor-pointer`}
                style={{
                  borderRadius: '10px',
                  right: '-29px',
                  bottom: '0',
                }}
                onClick={() => {
                  setIsCommentReaction(true);
                  setReactionCommentData(comment?.reactions);
                  setReactionCommentId(comment?.id);
                  setEmojiCountModal(true);
                  dispatch(
                    setRoomEditData({
                      name: 'commentReactionList',
                      key: 'commentId',
                      value: comment?.id,
                    })
                  );
                }}
              >
                <span>
                  {comment?.reactions
                    ? calculateTopThreeEmojisUsed(comment?.reactions)?.map((el) =>
                        emojis?.map((em) => {
                          if (el?.reaction === em?.title) return em?.value;
                        })
                      )
                    : emojis[0].value}
                </span>
                <span className={`ml-1`}>
                  {comment?.reactions?.length
                    ? calculateTotalCountLikes(comment?.reactions)
                    : comment?.no_of_likes}
                </span>
              </div>
            )}
          </div>
          <div
            className="comment-controls d-flex gap-3 justify-content-between align-items-center"
            style={{ width: '217px' }}
          >
            <span className="d-time light-text">
              {moment(comment?.created_at).fromNow()}
            </span>
            <div className="like-count  d-flex justify-content-start align-items-center cursor-pointer">
              <div className="position-relative">
                <span className="comment--like">
                  {comment?.user_reaction || comment?.like ? (
                    comment?.user_reaction ? (
                      emojis?.map((el) => {
                        if (comment?.user_reaction === el?.title)
                          return (
                            <span
                              onClick={() =>
                                onCommentLikeClick(
                                  comment?.id,
                                  each?.id,
                                  comment?.user_reaction
                                )
                              }
                              className={`cursor-pointer ${getReactColor(
                                comment?.user_reaction
                              )}`}
                              style={{
                                fontWeight: '600',
                              }}
                            >
                              {el?.slug}
                            </span>
                          );
                      })
                    ) : (
                      <span
                        className="text-primary cursor-pointer"
                        onClick={() =>
                          onCommentLikeClick(comment?.id, each?.id, 'LIKE')
                        }
                        style={{
                          fontWeight: '600',
                        }}
                      >
                        Like
                      </span>
                    )
                  ) : (
                    <span
                      className="cursor-pointer"
                      onClick={() =>
                        onCommentLikeClick(comment?.id, each?.id, 'LIKE')
                      }
                      style={{
                        fontWeight: '600',
                      }}
                    >
                      Like
                    </span>
                  )}
                  <div className="position-absolute bg-primary px-2 comment--like__react align-items-center m-auto ">
                    {emojis?.map((el, i) => (
                      <span
                        key={i}
                        style={{ fontSize: '19px' }}
                        className={`${
                          emojis?.length === i + 1 ? '' : 'mr-2 '
                        } cursor-pointer like--react__icons d-block`}
                        onClick={(e) => {
                          e.stopPropagation();
                          onCommentLikeClick(comment?.id, each?.id, el?.title);
                        }}
                      >
                        {el?.value}
                      </span>
                    ))}
                  </div>
                </span>
              </div>
            </div>
            <div className="like-count d-flex justify-content-start align-items-center cursor-pointer">
              <span
                className="cursor-pointer"
                onClick={() => {
                  setCommentUserName(
                    `${comment?.created_by?.first_name} ${comment?.created_by?.last_name}`
                  );
                  handleShowReplyClick(comment?.id);
                  onReplyClick(comment?.id);
                }}
                style={{
                  fontWeight: '600',
                }}
              >
                Reply
              </span>
            </div>
          </div>
        </div>
        <div className="ml-auto">
          {user?.id === comment.created_by.id && (
            <Dropdown
              overlay={<CommentMenu comment={comment} each={each} />}
              placement="bottomLeft"
              className="dropdown-ml edit-comment-button ml-auto"
              trigger={['click']}
              overlayStyle={{ minWidth: '160px' }}
            >
              <div className="edit-post-button">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <circle cx="12" cy="12" r="1"></circle>
                  <circle cx="12" cy="5" r="1"></circle>
                  <circle cx="12" cy="19" r="1"></circle>
                </svg>
              </div>
            </Dropdown>
          )}
        </div>
      </div>
    </>
  );
};

export default CommentContent;
